import React, { useState, useEffect, useRef } from 'react'
import { Modal, Select, Col, Row, Form, Button, Typography, Checkbox, Skeleton, Collapse } from 'antd'
import { FaAngleDown, FaRegEnvelope } from "react-icons/fa";
import moment from 'moment';
import { getfilteredCountries } from '../../../utils/Constants';
import { fetchFlightBookTripjackProceed, getIPAddress, getIPData, payNowConfirmTripjack } from '../../../services/flight/flightServices';
import DepartureBaggageDetails from './DepartureBaggageDetails';
import ReturnBaggageDetails from './ReturnBaggageDetails';
import DepartureReviewCard from './DepartureReviewCard';
import ReturnReviewCard from './ReturnReviewCard';
import { flightLoader } from '../../../utils/ImagePath';
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import TextArea from 'antd/es/input/TextArea';
import { Link, useNavigate } from 'react-router-dom';
import TravellerDetailsTripjack from './TravellerDetailsTripjack';
import PriceFareMobileViewTripJack from './PriceFareMobileViewTripJack';
import BookingFilterTripjack from './BookingFilterTripjack';
import AddonsFlightTripJack from './AddonsFlightTripJack';
import ConvenienceChargeTotalFareTripjack from './ConvenienceChargeTotalFareTripjack';
import FlightSummaryCollapseTripjack from './FlightSummaryCollapseTripjack';
import FilteredInput from '../../../layout/FilteredInput';
import TravellersCardCollapseTripjack from './TravellersCardCollapseTripjack';

const BookingFlightTripJack = ({
    flightDetails,
    loading,
    setSelectedBaggages,
    selectedBaggages,
    totalAmount,
    setTotalAmount,
    addBaggage,
    removeBaggage,
    totalBookingPrice,
    totalSelectMeals,
    addMeal,
    removeMeal,
    selectedMeals,
    selectedMealsReturn,
    addMealReturn,
    mealTotalAmountRetrun,
    removeMealReturn,
    priceIds,
    convenienceCharge,
    swtFee,
    TotalAmountConvenienceCharge,
    applyDiscountShow,
    applicableChargeData,
    calculatedFee,
    finalTotal,
    discountAmountOffer,
    couponId,
    setCouponId,
    setApplyDiscountShow,
    setDiscountAmountOffer,
    totalAfterDiscount,
    setTotalAfterDiscount,
    addBaggageReturn,
    removeBaggageReturn,
    setSelectedBaggagesReturn,
    selectedBaggagesReturn,
    totalAmountBaggageReturn,
    outputMealBaggage,
    collapseCard,
    setCollapseCard,
    setConvenienceChargeTotalFareModal,
    convenienceChargeTotalFareModal,
    mealTotalAmount,
    skipAddonAndPayNow,
    collapseCardTravellers,
    setCollapseCardTravellers,
    totalSeatPrice,
    setTotalSeatPrice,
    selectedSeats,
    setSelectedSeats,
    seatsList,
    setSeatsList,

    setSelectedMeals,
    setMealTotalAmount,
    setSelectedMealsReturn,
    setMealTotalAmountReturn,

    totalSeatsPriceReturn,
    setTotalSeatPriceReturn,
    selectedSeatsReturn,
    setSelectedSeatsReturn,
    seatsListReturn,
    setSeatsListReturn,
    setTotalAmountBaggageReturn
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenReturn, setIsModalOpenReturn] = useState(false);
    const [isModalTravellerDetails, setIsModalOpenTravellerDetails] = useState(false);
    const [selectPayloadData, setSelectPayloadData] = useState('')
    const [forms, setForms] = useState([]);
    const [formsChild, setFormsChild] = useState([]);
    const [formsInfant, setFormsInfant] = useState([]);
    const [checked, setChecked] = useState(false);
    const [addonsCompHide, setAddonsCompHide] = useState(null)
    const [bookingLoader, setBookingLoader] = useState(null)
    const [bookingMessage, setBookingMessage] = useState(null)
    const [bookingMessageError, setBookingMessageError] = useState(null)
    const [phone, setPhone] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isValidReq, setIsValidReq] = useState(false);
    const [locationData, setLocationData] = useState(null);
    const [form] = Form.useForm();
    const { Panel } = Collapse;
    const { Title } = Typography;
    const navigate = useNavigate();
    useEffect(() => {
        const initialForms = Array.from({ length: flightDetails?.searchQuery?.paxInfo?.ADULT }, () => ({}));
        const formsChildForms = Array.from({ length: flightDetails?.searchQuery?.paxInfo?.CHILD }, () => ({}));
        const formsInfantForms = Array.from({ length: flightDetails?.searchQuery?.paxInfo?.INFANT }, () => ({}));
        setForms(initialForms);
        setFormsChild(formsChildForms);
        setFormsInfant(formsInfantForms);
    }, [flightDetails?.searchQuery?.paxInfo?.ADULT, flightDetails?.searchQuery?.paxInfo?.CHILD, flightDetails?.searchQuery?.paxInfo?.INFANT]);

    // Days array from 1 to 31
    const days = Array.from({ length: 31 }, (_, i) => i + 1);

    // Months array
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    // Current year
    const currentYear = new Date().getFullYear();

    // Past 10 years array
    const pastYears = Array.from({ length: 10 }, (_, i) => currentYear - i);

    // Past 10 years array for passport validation
    const pastPassportYears = Array.from({ length: 10 }, (_, i) => currentYear - i);

    // Future 10 years array for passport validation
    const futurePassportYears = Array.from({ length: 10 }, (_, i) => currentYear + i);
    // Adult age years array (from 12 to 112 years ago)
    const startYearAdult = currentYear - 12;
    const endYearAdult = startYearAdult - 100 + 1;
    const AdultAgeYears = Array.from({ length: startYearAdult - endYearAdult + 1 }, (_, i) => startYearAdult - i);

    // Child age years array (from 2 to 12 years ago)
    const startYearChild = currentYear - 2;
    const endYearChild = currentYear - 12;
    const ChildYears = Array.from({ length: startYearChild - endYearChild + 1 }, (_, i) => startYearChild - i);

    // Future 50 years array
    const futureYears = Array.from({ length: 50 }, (_, i) => currentYear + i);

    // Infant age years array (from 0 to 2 years ago)
    const startYearInfant = currentYear;
    const endYearInfant = currentYear - 2;
    const InfantYears = Array.from({ length: startYearInfant - endYearInfant + 1 }, (_, i) => startYearInfant - i);
    const today = new Date();


    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();


    const getFromSessionStorage = (key, defaultValue = null) => {
        const value = sessionStorage.getItem(key);
        if (value === null || value === undefined) {
            return defaultValue;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing sessionStorage key "${key}":`, e);
            return defaultValue;
        }
    };

    const flightData = {
        departureFlight: getFromSessionStorage('DepartureFlight'),
    };

    const travel_date = moment(flightData?.departureFlight).format('YYYY-MM-DD');

    const travelDate = new Date(travel_date);
    const minimumAllowedDOBInfant = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
    const minimumAllowedDOBChild = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
    const maximumAllowedDOBChild = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());

    const handleChange = (index, key, value) => {
        const newForms = [...forms];
        newForms[index][key] = value;
        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear, passportExpiryDay, passportExpiryMonth, passportExpiryYear } = newForms[index];
        if (dobDay && dobMonth && dobYear) {
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, '0')}-${String(dobDay).padStart(2, '0')}`;
        }
        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }

        if (passportExpiryDay && passportExpiryMonth && passportExpiryYear) {
            newForms[index].passportExpiry = `${passportExpiryYear}-${String(passportExpiryMonth).padStart(2, '0')}-${String(passportExpiryDay).padStart(2, '0')}`;
        }
        setForms(newForms);
    };

    const handleChangeChild = (index, key, value) => {
        const newForms = [...formsChild];
        newForms[index][key] = value;

        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear, passportExpiryDay, passportExpiryMonth, passportExpiryYear } = newForms[index];

        if (dobDay && dobMonth && dobYear) {
            const dob = new Date(`${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`);
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`;

            if (dob > today) {
                newForms[index].dobError = "Date of Birth cannot be in the future.";
            } else if (dob < minimumAllowedDOBChild || dob > maximumAllowedDOBChild) {
                newForms[index].dobError = `Child age must be between 2 and 12 years from the travel date.`;
            } else if (dob.getMonth() + 1 !== dobMonth) { // If the month/day combination is invalid for the given year
                newForms[index].dobError = `Invalid month for the selected day.`;
                newForms[index].dobMonth = null; // Unselect the month
            } else if (dob.getDate() !== dobDay) { // Check if the day is valid for the selected month
                newForms[index].dobError = `Invalid day for the selected month.`;
                newForms[index].dobDay = null; // Unselect the day
            } else {
                newForms[index].dobError = null;
            }
        } else {
            newForms[index].dob = "";
            newForms[index].dobError = "Please complete day, month, and year.";
        }

        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }
        if (passportExpiryDay && passportExpiryMonth && passportExpiryYear) {
            newForms[index].passportExpiry = `${passportExpiryYear}-${String(passportExpiryMonth).padStart(2, '0')}-${String(passportExpiryDay).padStart(2, '0')}`;
        }
        setFormsChild(newForms);
    };


    const handleChangeInfant = (index, key, value) => {
        const newForms = [...formsInfant];
        newForms[index][key] = value;
        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear, passportExpiryDay, passportExpiryMonth, passportExpiryYear } = newForms[index];
        if (dobDay && dobMonth && dobYear) {
            const dob = new Date(`${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`);
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`;
            // Check if the date is in the future
            if (dob > today) {
                newForms[index].dobError = "Date of Birth cannot be in the future.";
                newForms[index].dobMonth = null; // Unselect the month
                newForms[index].dobDay = null; // Unselect the day
            } else if (dob.getMonth() + 1 !== dobMonth) { // If the month/day combination is invalid for the given year
                newForms[index].dobError = `Invalid month for the selected day.`;
                newForms[index].dobMonth = null; // Unselect the month
            } else if (dob.getDate() !== dobDay) { // Check if the day is valid for the selected month
                newForms[index].dobError = `Invalid day for the selected month.`;
                newForms[index].dobDay = null; // Unselect the day
            } else if (dob < minimumAllowedDOBInfant) { // Check if the date is too far in the past (less than 2 years from today)
                newForms[index].dobError = `Infant age must be less than 2 years from the travel date.`;
                newForms[index].dobMonth = null; // Unselect the month
                newForms[index].dobDay = null; // Unselect the day
            } else {
                newForms[index].dobError = null;
            }
        } else { // If any of the day, month, or year is missing
            newForms[index].dobError = "Please select a valid date.";
        }
        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }
        if (passportExpiryDay && passportExpiryMonth && passportExpiryYear) {
            newForms[index].passportExpiry = `${passportExpiryYear}-${String(passportExpiryMonth).padStart(2, '0')}-${String(passportExpiryDay).padStart(2, '0')}`;
        }
        setFormsInfant(newForms);
    };

    const getDisabledMonths = (selectedYear) => {
        if (selectedYear === undefined || selectedYear === null) {
            return [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
        } else if (selectedYear < currentYear) return [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        return months.slice(0, currentMonth);
    };

    const getDisabledDays = (selectedYear, selectedMonth) => {
        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
        if (selectedYear < currentYear || selectedMonth < currentMonth) {
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        };
        if (selectedYear === currentYear && selectedMonth === currentMonth) return days.slice(0, currentDay);
        return days;
    };

    const onChange = (e) => {
        setChecked(e.target.checked);
    };


    const generateTravellerInfo = (adults, children, infants, values) => {
        const paxTypeMapping = {
            ADULT: 1,
            CHILD: 2,
            INFANT: 3,
        };
        const createTraveller = (pt, index) => {
            const ti = values[`${pt}_title${index}`];
            const fN = values[`${pt}_firstname${index}`];
            const lN = values[`${pt}_lastname${index}`];
            const pNat = values[`${pt}_Nationality${index}`] || "IN";
            const pNum = values[`${pt}_passportId${index}`];
            const Gender = values[`${pt}_gender${index}`] === "Male" ? 1 : 2;

            let dob, pid, eD;
            if (pt === "ADULT") {
                dob = forms[index].dob;
                pid = forms[index].PassportIssuing;
                eD = forms[index].passportExpiry;
            } else if (pt === "CHILD") {
                dob = formsChild?.[index]?.dob;
                pid = forms?.[index]?.PassportIssuing;
                eD = formsChild?.[index]?.passportExpiry;
            } else if (pt === "INFANT") {
                dob = formsInfant?.[index]?.dob;
                pid = forms?.[index]?.PassportIssuing;;
                eD = formsInfant?.[index]?.passportExpiry;
            }

            return {
                ti,
                fN,
                lN,
                pt: paxTypeMapping[pt],
                Gender,
                pNat,
                pNum,
                eD,
                dob,
                pid,
            };
        };

        let travellerInfo = [];

        for (let i = 0; i < adults; i++) {
            travellerInfo.push(createTraveller("ADULT", i));
        }
        for (let i = 0; i < children; i++) {
            travellerInfo.push(createTraveller("CHILD", i));
        }
        for (let i = 0; i < infants; i++) {
            travellerInfo.push(createTraveller("INFANT", i));
        }

        return travellerInfo;
    };

    const createGstInfo = (values) => ({
        gstNumber: values?.gstNumber,
        email: values?.businessEmail,
        registeredName: values?.companyName,
        mobile: values?.mobile,
        address: values?.companyAddress
    });

    const [proceedbookingId, setProceedbookingId] = useState(null);
    const [countryCode, setCountryCode] = useState(null);

    const onFinishFailed = () => {
        setTimeout(() => {
            const errorElements = document.querySelectorAll(".ant-form-item-has-error");

            if (errorElements.length > 0) {
                const firstError = errorElements[0];
                const collapsePanel = firstError.closest(".ant-collapse-item");

                // 1️⃣ Find the key of the collapse panel with the error
                if (collapsePanel) {
                    const panelKey = collapsePanel.getAttribute("data-panel-key");

                    // 2️⃣ Open the panel if it's closed
                    if (panelKey && !activeKeys.includes(panelKey)) {
                        setActiveKeys((prev) => [...prev, panelKey]);
                    }
                }

                // 3️⃣ Smoothly scroll to the error field
                const elementRect = firstError.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.pageYOffset;
                const offset = 120; // adjust if header present
                const scrollToPosition = absoluteElementTop - offset;

                window.scrollTo({
                    top: scrollToPosition,
                    behavior: "smooth",
                });
            }
        }, 100);
    };

    const onPayment = (values) => {
        // let invalidForm = false;
        setBookingLoader(true);
        const travellerInfo = generateTravellerInfo(
            flightDetails?.searchQuery?.paxInfo?.ADULT,
            flightDetails?.searchQuery?.paxInfo?.CHILD,
            flightDetails?.searchQuery?.paxInfo?.INFANT,
            values
        );
        setCollapseCardTravellers(false);
        // if (invalidForm) {
        //     handleScroll();
        //     return;
        // }

        const payload = {
            priceIds: priceIds?.priceIds,
            bookingId: flightDetails?.bookingId,
            cabinClass: flightDetails?.tripInfos?.[0]?.totalPriceList[0]?.fd?.ADULT?.cc,
            paymentInfos: [{ amount: Number(totalBookingPrice) }],
            travellerInfo,
            ...(checked && { gstInfo: createGstInfo(values) }),
            deliveryInfo: {
                emails: [values?.email],
                contacts: [countryCode],
            }
        };
        fetchFlightBookTripjackProceed(payload)
            .then((response) => {
                setIsModalOpenTravellerDetails(true)
                setSelectPayloadData(payload)
                setBookingLoader(false);
                const newBookingId = response?.bookingId;
                setProceedbookingId(newBookingId);
                sessionStorage.setItem('currentBookingId', newBookingId);
            })
            .catch((error) => {
                // console.log("Error message", error?.response?.data?.message);
                setBookingMessageError(true);
                setBookingMessage(error?.response?.data?.message);
            });

    };

    const [phoneValue, setPhoneValue] = useState('');
    const [activePanels, setActivePanels] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const getAllPanelKeys = () => {
        return [
            ...forms.map((_, i) => i.toString()),
            ...formsChild.map((_, i) => (forms.length + i).toString()),
            ...formsInfant.map((_, i) => (forms.length + formsChild.length + i).toString())
        ];
    };
    const handleConfirmAndPay = async () => {
        setBookingLoader(true);
        const currentBookingId = sessionStorage.getItem('currentBookingId') || proceedbookingId;
        // if (!currentBookingId) {
        //     alert('Invalid booking session');
        //     return;
        // }
        const payload = {
            bookingId: currentBookingId,
            convenience_id: applicableChargeData?.id,
            ...(applyDiscountShow && { coupon_id: Number(couponId) }),
            flight: outputMealBaggage
        };
        try {
            const response = await payNowConfirmTripjack(payload);
            setBookingLoader(false);
            setIsModalOpenTravellerDetails(false)
            if (response?.payment_links?.web) {
                sessionStorage.removeItem('currentBookingId');
                window.location.href = response.payment_links.web;
            }

        } catch (error) {
            setBookingLoader(true);
            setIsModalOpenTravellerDetails(false);
            console.error("Payment Error:", error);
        }
    };

    const handleProceed = async () => {
        try {
            await form.validateFields();
        } catch (error) {
            const errorFields = error.errorFields.map((field) => field.name[0]);

            let errorPanels = [...new Set(errorFields.map((field) => {
                if (field.startsWith("ADULT")) {
                    return field.match(/\d+/)?.[0];
                } else if (field.startsWith("CHILD")) {
                    return (forms.length + parseInt(field.match(/\d+/)?.[0] || "0")).toString();
                } else if (field.startsWith("INFANT")) {
                    return (forms.length + formsChild.length + parseInt(field.match(/\d+/)?.[0] || "0")).toString();
                }
                return null;
            }).filter((index) => index !== null))];

            setActivePanels(errorPanels);

            // Scroll to the first error field
            setTimeout(() => {
                const firstErrorField = document.querySelector(".ant-form-item-has-error");
                if (firstErrorField) {
                    firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 500);
            return;
        }

        // if (!phone.trim()) {
        //     setIsValidReq(true);
        //     return;
        // }
        // if (!isValid) return;

        let newActivePanels = [];

        for (let i = 0; i < forms.length; i++) {
            const adultTitle = form.getFieldValue(`ADULT_title${i}`);
            if (!adultTitle) {
                newActivePanels.push(i.toString());
            }
        }

        for (let i = 0; i < formsChild.length; i++) {
            const childTitle = form.getFieldValue(`CHILD_title${i}`);
            if (!childTitle) {
                newActivePanels.push((forms.length + i).toString());
            }
        }

        let updatedInfants = formsInfant.map((form, index) => {
            if (!form.dobDay || !form.dobMonth || !form.dobYear) {
                newActivePanels.push((forms.length + formsChild.length + index).toString());
                return { ...form, dobError: "Date of Birth is required." };
            }
            return { ...form, dobError: null };
        });
        setFormsInfant(updatedInfants);

        if (newActivePanels.length > 0) {
            setActivePanels([...new Set(newActivePanels)]);
            return;
        }

        const fields = form.getFieldsValue(true);
        onPayment(fields);
    };

    useEffect(() => {
        const fetchIPAddress = async () => {
            try {
                const ip = await getIPAddress();
                const data = await getIPData(ip?.ip);
                setLocationData(data);
            } catch (error) {
                console.log("error", error)
            }
        };

        fetchIPAddress();
    }, []);

    const validatePhone = (_, value) => {
        if (!value || value.trim() === "" || value === "+91") {
            return Promise.reject(new Error("Mobile number is required"));
        }
        const phoneNumber = parsePhoneNumberFromString(countryCode);
        if (!phoneNumber || !phoneNumber.isValid()) {
            return Promise.reject(new Error("Enter a valid mobile number"));
        }
        return Promise.resolve();
    };

    const handlePhoneChange = (value) => {
        setCountryCode(value)
        const sanitized = value.replace("+91", "").trim();
        setPhoneValue(sanitized);
        form.setFieldsValue({ contacts: sanitized });
    };

    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const component4Ref = useRef(null);

    const handleScroll = () => {
        if (component4Ref.current) {
            const elementPosition = component4Ref.current.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        if (addonsCompHide) {
            setTimeout(() => {
                handleScroll();
            }, 100);
        }
    }, [addonsCompHide]);

    const getExpiryYears = (issuingYear) => {
        const currentYear = new Date().getFullYear();
        const startYear = issuingYear || currentYear;
        const years = [];
        for (let y = startYear; y <= startYear + 10; y++) {
            years.push(y);
        }
        return years;
    };

    const handleActivePanelsChange = (keys) => {
        setActivePanels(keys);
        setIsInitialLoad(false);
    };

    const handleEditClick = () => {
        setCollapseCard(true);
        setCollapseCardTravellers(true);
        setAddonsCompHide(false);
        // setMealTotalAmount(0);
        // setMealTotalAmountReturn(0);
        setTotalAmount(0);
        // setTotalAmountReturn(0);
        // setSelectedMeals({});
        // setSelectedMealsReturn({});
        setSelectedBaggages([]);
        setSelectedBaggagesReturn([]);
        form.resetFields(["agree"]);
        setActivePanels(getAllPanelKeys());
        setIsInitialLoad(false);
    };

    useEffect(() => {
        if (isInitialLoad && forms.length > 0) {
            setActivePanels(['0']);
        }
    }, [forms.length, isInitialLoad]);



    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [hasTriedSubmit, setHasTriedSubmit] = useState(false);
    const allValues = Form.useWatch([], form);

    useEffect(() => {
        const timeoutId = setTimeout(async () => {
            if (!hasTriedSubmit && !isCheckboxChecked) return;
            if (!isValid && phone) {
                setIsFormValid(false);
                return;
            }
            try {
                await form.validateFields();
                const hasInfantDOBError = formsInfant.some(
                    form => !form.dobDay || !form.dobMonth || !form.dobYear
                );
                setIsFormValid(!hasInfantDOBError && isCheckboxChecked);
            } catch {
                setIsFormValid(false);
            }
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [allValues, formsInfant, hasTriedSubmit, isCheckboxChecked, phone]);

    const validateName = (_, value) => {
        if (!value) return Promise.reject("This field is required");
        const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
        if (!nameRegex.test(value)) {
            return Promise.reject("Only letters and single space between words");
        }
        if (value.length < 2 || value.length > 100) {
            return Promise.reject("Must be 2–100 characters");
        }
        return Promise.resolve();
    };

    const sanitizeName = (e) => {
        let value = e.target.value || "";
        value = value.replace(/^\s+/, "");
        value = value.replace(/\s{2,}/g, " ");
        value = value.replace(/[^A-Za-z ]/g, "");
        return value;
    };


    return (
        <div>
            {!collapseCard &&
                <FlightSummaryCollapseTripjack
                    flightDetails={flightDetails}
                    collapseCard={collapseCard}
                    setCollapseCard={setCollapseCard}
                    setAddonsCompHide={setAddonsCompHide}
                />
            }
            {collapseCard &&
                <>
                    <DepartureReviewCard
                        flightDetails={flightDetails}
                        loading={loading}
                        setIsModalOpen={setIsModalOpen}
                    />
                    {/*  Retrun booking review card */}
                    {flightDetails?.tripInfos?.[1] !== undefined &&
                        <ReturnReviewCard
                            flightDetails={flightDetails}
                            loading={loading}
                            setIsModalOpenReturn={setIsModalOpenReturn}
                        />
                    }
                </>
            }
            {/*  Departure booking review card */}

            {collapseCard &&
                <div className="d-md-none">
                    <BookingFilterTripjack
                        flightDetails={flightDetails}
                        loading={loading}
                        setSelectedBaggages={setSelectedBaggages}
                        selectedBaggages={selectedBaggages}
                        totalAmount={totalAmount}
                        totalBookingPrice={totalBookingPrice}
                        setTotalAmount={setTotalAmount}
                        addBaggage={addBaggage}
                        removeBaggage={removeBaggage}
                        totalSelectMeals={totalSelectMeals}


                        applyDiscountShow={applyDiscountShow}
                        applicableChargeData={applicableChargeData}
                        calculatedFee={calculatedFee}
                        finalTotal={finalTotal}

                        setCouponId={setCouponId}
                        couponId={couponId}
                        setApplyDiscountShow={setApplyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        setDiscountAmountOffer={setDiscountAmountOffer}
                        totalAfterDiscount={totalAfterDiscount}
                        setTotalAfterDiscount={setTotalAfterDiscount}

                        mealTotalAmountRetrun={mealTotalAmountRetrun}
                        totalAmountBaggageReturn={totalAmountBaggageReturn}

                    />
                </div>
            }
            <div>

                {!collapseCard &&
                    <div className="card flights-accordion traveller-details mb-0" id='TravellerDetails'>
                        <div className="card-header d-flex justify-content-between align-items-center" onClick={() => setCollapseCardTravellers(!collapseCardTravellers)} style={{ cursor: "pointer" }}>
                            <div className='d-flex'>
                                <h3 className='me-2'>Traveller Details  </h3>
                                {!collapseCard && <p>{selectPayloadData?.travellerInfo
                                    ?.map((traveller) => `${traveller.fN} ${traveller.lN}`)
                                    .join(', ')}</p>}
                            </div>
                            {!collapseCard && <FaAngleDown />}
                        </div>

                        {collapseCardTravellers &&
                            <TravellersCardCollapseTripjack
                                selectPayloadData={selectPayloadData}
                                handleEditClick={handleEditClick}
                            />
                        }
                    </div>
                }


                <Form
                    form={form}
                    // onFinish={addonsCompHide ? onPayment : onFinish}
                    layout="vertical"
                    autoCapitalize='off'
                    onFinish={onPayment}
                    onFinishFailed={onFinishFailed}
                >
                    <Skeleton
                        paragraph={{ rows: 4, }}
                        loading={loading}
                        style={{ background: "#fff" }}
                        className='p-4 mb-4'
                    >

                        <div className="card flights-accordion traveller-details mb-md-0 mb-5">

                            {collapseCard &&
                                <>
                                    <div className="card-header d-flex justify-content-between align-items-center cursor-pointer">
                                        <div className='d-flex'>
                                            <h3 className='me-2'>Traveller Details   </h3>
                                        </div>
                                    </div>

                                </>
                            }

                            {collapseCard &&
                                <div className="flights-list-item bg-white rounded-3 p-3">
                                    <Collapse
                                        // accordion
                                        // activeKey={activePanels}
                                        // onChange={(keys) => setActivePanels(keys)}
                                        activeKey={activePanels}
                                        accordion={false}
                                        onChange={handleActivePanelsChange}
                                        className='mt-2'
                                    >
                                        {forms.map((form, index) => (
                                            <Panel header={`Adult ${index + 1}`} key={index.toString()}>
                                                <Row gutter={16} key={index} className=''>

                                                    <Col md={4} className='w-100'>
                                                        <Form.Item
                                                            label="Title"
                                                            name={`ADULT_title${index}`}
                                                            className="mb-3 pulse_input"

                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Title is required",
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder='Select'
                                                            >
                                                                <Option value="Mr">Mr</Option>
                                                                <Option value="Ms">Ms</Option>
                                                                <Option value="Mrs">Mrs</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col md={8} className='w-100'>
                                                        <Form.Item
                                                            name={`ADULT_firstname${index}`}
                                                            label="First Name"
                                                            className="mb-3 pulse_input"
                                                            rules={[{ validator: validateName }]}
                                                            getValueFromEvent={sanitizeName}
                                                        >
                                                            <FilteredInput
                                                                placeholder='Enter your first name'
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col md={8} className='w-100'>
                                                        <Form.Item
                                                            name={`ADULT_lastname${index}`}
                                                            label="Last Name"
                                                            className="mb-3 pulse_input"
                                                            rules={[{ validator: validateName }]}
                                                            getValueFromEvent={sanitizeName}
                                                        >
                                                            <FilteredInput
                                                                placeholder='Enter your last name'
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col md={4} className='w-100'>
                                                        <Form.Item
                                                            label="Gender"
                                                            name={`ADULT_gender${index}`}
                                                            className="mb-3 pulse_input"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Gender is required",
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder='Select Gender'
                                                            >
                                                                <Option value="Male">Male</Option>
                                                                <Option value="Female">Female</Option>
                                                                <Option value="Other">Other</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    {!flightDetails?.searchQuery?.isDomestic &&
                                                        <>
                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`dob${index}`}
                                                                    label="Date of Birth"
                                                                    validateTrigger="onBlur"
                                                                    rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const { dobDay, dobMonth, dobYear } = forms[index] || {};
                                                                                if (!dobDay || !dobMonth || !dobYear) {
                                                                                    return Promise.reject(new Error("Date of birth  is required"));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Row gutter={4}>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Day"
                                                                                value={form.dobDay}
                                                                                onChange={(value) => handleChange(index, 'dobDay', value)}
                                                                                style={{ width: '100%' }}

                                                                            >
                                                                                {days.map(d => (
                                                                                    <Select.Option key={`dob-day-${d}`} value={d}>{d}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Month"
                                                                                value={form.dobMonth}
                                                                                onChange={(value) => handleChange(index, 'dobMonth', value)}
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {months.map((m, idx) => (
                                                                                    <Select.Option key={`dob-month-${idx + 1}`} value={idx + 1}>{m}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>

                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Year"
                                                                                value={form.dobYear}
                                                                                onChange={(value) => handleChange(index, 'dobYear', value)}
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {AdultAgeYears.map(y => (
                                                                                    <Select.Option key={`dob-year-${y}`} value={y}>{y}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>

                                                                    </Row>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    label="Nationality"
                                                                    name={`ADULT_Nationality${index}`}
                                                                    className="mb-3 pulse_input"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Nationality is required",
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="Select a country"
                                                                        optionFilterProp="label"
                                                                        value={form.passportIssuingCountry}
                                                                        onChange={(value) => handleChange(index, 'passportIssuingCountry', value)}
                                                                        options={getfilteredCountries.map((country, i) => ({
                                                                            value: country.code,
                                                                            label: country.name
                                                                        }))}
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`ADULT_passportId${index}`}
                                                                    label="Passport Number"
                                                                    className="mb-3 pulse_input"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Passport Number is required!",
                                                                        },
                                                                        {
                                                                            pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                            message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                        },
                                                                    ]}
                                                                >
                                                                    <FilteredInput
                                                                        placeholder='Enter your passport number'
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`PassportIssuing${index}`}
                                                                    label="Passport Issue Date"
                                                                    validateTrigger="onBlur"
                                                                    rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const { passportIssuingDay, passportIssuingMonth, passportIssuingYear } = forms[index] || {};
                                                                                if (!passportIssuingDay || !passportIssuingMonth || !passportIssuingYear) {
                                                                                    return Promise.reject(new Error("Passport Issue Date is required"));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Row gutter={4} className=''>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Day"
                                                                                onChange={(value) => handleChange(index, 'passportIssuingDay', value)}
                                                                                value={form.passportIssuingDay}
                                                                                style={{ width: '75px' }}
                                                                            >
                                                                                {days.map(d => (
                                                                                    <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Month"
                                                                                onChange={(value) => handleChange(index, 'passportIssuingMonth', value)}
                                                                                value={form.passportIssuingMonth}
                                                                                style={{ width: '75px' }}
                                                                            >
                                                                                {months.map((m, idx) => (
                                                                                    <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Year"
                                                                                onChange={(value) => handleChange(index, 'passportIssuingYear', value)}
                                                                                value={form.passportIssuingYear}
                                                                                style={{ width: '80px' }}
                                                                            >
                                                                                {pastPassportYears.map(y => (
                                                                                    <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`PassportExpiry${index}`}
                                                                    label="Passport Expiry Date"
                                                                    validateTrigger="onBlur"
                                                                    rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const { passportExpiryDay, passportExpiryMonth, passportExpiryYear } = forms[index] || {};
                                                                                if (!passportExpiryDay || !passportExpiryMonth || !passportExpiryYear) {
                                                                                    return Promise.reject(new Error("Passport expiry date is required"));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Row gutter={4}>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Day"
                                                                                onChange={(value) => handleChange(index, 'passportExpiryDay', value)}
                                                                                value={form.passportExpiryDay}
                                                                                style={{ width: '75px' }}
                                                                            >
                                                                                {days.map(d => (
                                                                                    <Option key={`expiry-day-${d}`} value={d}>{d}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Month"
                                                                                onChange={(value) => handleChange(index, 'passportExpiryMonth', value)}
                                                                                value={form.passportExpiryMonth}
                                                                                style={{ width: '75px' }}
                                                                            >
                                                                                {months.map((m, idx) => (
                                                                                    <Option key={`expiry-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Year"
                                                                                onChange={(value) => handleChange(index, 'passportExpiryYear', value)}
                                                                                value={form.passportExpiryYear}
                                                                                style={{ width: '80px' }}
                                                                            >
                                                                                {getExpiryYears(form.passportIssuingYear).map((y) => (
                                                                                    <Option key={`expiry-year-${y}`} value={y}>{y}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Item>
                                                            </Col>
                                                        </>
                                                    }
                                                </Row>
                                            </Panel>
                                        ))}
                                        {/* </Collapse> */}

                                        {flightDetails?.searchQuery?.paxInfo?.CHILD !== 0 &&
                                            <>
                                                {formsChild.map((form, index) => (
                                                    // <Collapse accordion className='mt-2'
                                                    //     activeKey={activePanels}
                                                    //     onChange={(keys) => setActivePanels(keys)}
                                                    // >
                                                    <Panel header={`Child ${index + 1}`} key={(forms.length + index).toString()}>
                                                        <Row gutter={16} key={index} className=''>

                                                            <Col md={4} className='w-100'>
                                                                <Form.Item name={`CHILD_title${index}`} label="Title" className="mb-3 pulse_input" rules={[{ required: true, message: "Title is required" }]}>
                                                                    <Select placeholder='Select'>
                                                                        <Option value="Master">Master</Option>
                                                                        <Option value="Ms">Miss</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`CHILD_firstname${index}`}
                                                                    label="First Name"
                                                                    className="mb-3 pulse_input"
                                                                    rules={[{ validator: validateName }]}
                                                                    getValueFromEvent={sanitizeName}
                                                                >
                                                                    <FilteredInput placeholder='Enter your first name' />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`CHILD_lastname${index}`}
                                                                    label="Last Name"
                                                                    className="mb-3 pulse_input"
                                                                    rules={[{ validator: validateName }]}
                                                                    getValueFromEvent={sanitizeName}
                                                                >
                                                                    <FilteredInput
                                                                        placeholder='Enter your last name'
                                                                        value={form.lastname}
                                                                        onChange={(e) => handleChangeChild(index, 'lastname', e.target.value)}
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={4} className='w-100'>
                                                                <Form.Item
                                                                    label="Gender"
                                                                    name={`CHILD_gender${index}`}
                                                                    className="mb-3 pulse_input"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Gender is required",
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder='Select Gender'
                                                                    >
                                                                        <Option value="Male">Male</Option>
                                                                        <Option value="Female">Female</Option>
                                                                        <Option value="Other">Other</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            {!flightDetails?.searchQuery?.isDomestic &&
                                                                <>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`dob${index}`}
                                                                            label="Date of Birth"
                                                                            validateStatus={form.dobError ? "error" : ""}
                                                                            help={form.dobError || ""}
                                                                        >
                                                                            <Row gutter={4}>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        value={form.dobDay}
                                                                                        onChange={(value) => handleChangeChild(index, 'dobDay', value)}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {getDisabledDays(form.dobYear, form.dobMonth).map((d, indx) => (
                                                                                            <Select.Option key={`dob-day-${indx}`} value={d}>{d}</Select.Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        value={form.dobMonth}
                                                                                        onChange={(value) => handleChangeChild(index, 'dobMonth', value)}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {getDisabledMonths(form.dobYear).map((m, idx) => (
                                                                                            <Select.Option key={`dob-month-${idx + 1}`} value={idx + 1}>{m}</Select.Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        value={form.dobYear}
                                                                                        onChange={(value) => handleChangeChild(index, 'dobYear', value)}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {ChildYears.map((y, indx) => (
                                                                                            <Select.Option key={`dob-year-${indx}`} value={y}>{y}</Select.Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            label="Nationality"
                                                                            name={`CHILD_Nationality${index}`}
                                                                            className="mb-3 pulse_input"
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Nationality is required",
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="Select a country"
                                                                                optionFilterProp="label"
                                                                                value={form.passportIssuingCountry}
                                                                                onChange={(value) => handleChangeChild(index, 'passportIssuingCountry', value)}
                                                                                options={getfilteredCountries.map((country, i) => ({
                                                                                    value: country.code,
                                                                                    label: country.name
                                                                                }))}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`CHILD_passportId${index}`}
                                                                            label="Passport Number"
                                                                            className="mb-3 pulse_input"
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Passport Number is required!",
                                                                                },
                                                                                {
                                                                                    pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                                    message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <FilteredInput
                                                                                placeholder='Enter your passport number'
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    {/* <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportIssuing${index}`}
                                                                            label="Passport Expiry Date"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportIssuingDay, passportIssuingMonth, passportIssuingYear } = forms[index] || {};
                                                                                        if (!passportIssuingDay || !passportIssuingMonth || !passportIssuingYear) {
                                                                                            return Promise.reject(new Error("Passport Expiry date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4} className=''>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingDay', value)}
                                                                                        value={form.passportIssuingDay}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingMonth', value)}
                                                                                        value={form.passportIssuingMonth}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingYear', value)}
                                                                                        value={form.passportIssuingYear}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {futurePassportYears.map(y => (
                                                                                            <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col> */}

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportIssuing${index}`}
                                                                            label="Passport Issue Date"
                                                                            validateTrigger="onBlur"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportIssuingDay, passportIssuingMonth, passportIssuingYear } = forms[index] || {};
                                                                                        if (!passportIssuingDay || !passportIssuingMonth || !passportIssuingYear) {
                                                                                            return Promise.reject(new Error("Passport Issue Date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4} className=''>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingDay', value)}
                                                                                        value={form.passportIssuingDay}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingMonth', value)}
                                                                                        value={form.passportIssuingMonth}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportIssuingYear', value)}
                                                                                        value={form.passportIssuingYear}
                                                                                        style={{ width: '80px' }}
                                                                                    >
                                                                                        {pastPassportYears.map(y => (
                                                                                            <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportExpiry${index}`}
                                                                            label="Passport Expiry Date"
                                                                            validateTrigger="onBlur"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportExpiryDay, passportExpiryMonth, passportExpiryYear } = forms[index] || {};
                                                                                        if (!passportExpiryDay || !passportExpiryMonth || !passportExpiryYear) {
                                                                                            return Promise.reject(new Error("Passport expiry date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4}>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportExpiryDay', value)}
                                                                                        value={form.passportExpiryDay}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`expiry-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportExpiryMonth', value)}
                                                                                        value={form.passportExpiryMonth}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`expiry-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeChild(index, 'passportExpiryYear', value)}
                                                                                        value={form.passportExpiryYear}
                                                                                        style={{ width: '80px' }}
                                                                                    >
                                                                                        {getExpiryYears(form.passportIssuingYear).map((y) => (
                                                                                            <Option key={`expiry-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col>

                                                                </>
                                                            }

                                                        </Row>
                                                    </Panel>
                                                    // </Collapse>
                                                ))}
                                            </>
                                        }

                                        {flightDetails?.searchQuery?.paxInfo?.INFANT !== 0 &&
                                            <>
                                                {formsInfant?.map((form, index) => (
                                                    // <Collapse accordion className='mt-2'
                                                    //     activeKey={activePanels}
                                                    //     onChange={(keys) => setActivePanels(keys)}>
                                                    <Panel header={`Infant ${index + 1}`} key={(forms.length + formsChild.length + index).toString()}>
                                                        <Row gutter={16} key={index} className=''>
                                                            <Col md={4} className='w-100'>
                                                                <Form.Item name={`INFANT_title${index}`} label="Title" className="mb-3 pulse_input" rules={[{ required: true, message: "Title is required" }]}>
                                                                    <Select placeholder='Select'>
                                                                        <Option value="Master">Master</Option>
                                                                        <Option value="Ms">Miss</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`INFANT_firstname${index}`}
                                                                    label="First Name"
                                                                    className="mb-3 pulse_input"
                                                                    rules={[{ validator: validateName }]}
                                                                    getValueFromEvent={sanitizeName}
                                                                >
                                                                    <FilteredInput
                                                                        placeholder='Enter your first name'
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    name={`INFANT_lastname${index}`}
                                                                    label="Last Name"
                                                                    className="mb-3 pulse_input"
                                                                    rules={[{ validator: validateName }]}
                                                                    getValueFromEvent={sanitizeName}
                                                                >
                                                                    <FilteredInput
                                                                        placeholder='Enter your last name'
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={4} className='w-100'>
                                                                <Form.Item
                                                                    label="Gender"
                                                                    name={`INFANT_gender${index}`}
                                                                    className="mb-3 pulse_input"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Gender is required",
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select placeholder='Select Gender' >
                                                                        <Option value="Male">Male</Option>
                                                                        <Option value="Female">Female</Option>
                                                                        <Option value="Other">Other</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col md={8} className='w-100'>
                                                                <Form.Item
                                                                    label="Date of Birth"
                                                                    validateStatus={form.dobError ? "error" : ""}
                                                                    help={form.dobError || ""}
                                                                >
                                                                    <Row gutter={4}>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Day"
                                                                                value={form.dobDay}
                                                                                onChange={(value) => handleChangeInfant(index, 'dobDay', value)}
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {getDisabledDays(form.dobYear, form.dobMonth).map((d, indx) => (
                                                                                    <Select.Option key={`dob-day-${indx + 2000}`} value={d}>{d}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Month"
                                                                                value={form.dobMonth}
                                                                                onChange={(value) => handleChangeInfant(index, 'dobMonth', value)}
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {getDisabledMonths(form.dobYear).map((m, idx) => (
                                                                                    <Select.Option key={`dob-month-${idx + 2000}`} value={idx + 1}>{m}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <Select
                                                                                placeholder="Year"
                                                                                value={form.dobYear}
                                                                                onChange={(value) => handleChangeInfant(index, 'dobYear', value)}
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {InfantYears.map((y, indx) => (
                                                                                    <Select.Option key={`dob-year-${indx}`} value={y}>{y}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Item>

                                                            </Col>

                                                            {!flightDetails?.searchQuery?.isDomestic &&
                                                                <>
                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            label="Nationality"
                                                                            name={`INFANT_Nationality${index}`}
                                                                            className="mb-3 pulse_input"
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Nationality is required",
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="Select a country"
                                                                                optionFilterProp="label"
                                                                                value={form.passportIssuingCountry}
                                                                                onChange={(e) => handleChangeInfant(index, 'passportIssuingCountry', e.target.value)}
                                                                                options={getfilteredCountries.map((country, i) => ({
                                                                                    value: country.code,
                                                                                    label: country.name
                                                                                }))}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`INFANT_passportId${index}`}
                                                                            label="Passport Number"
                                                                            className="mb-3 pulse_input"
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Passport Number is required!",
                                                                                },
                                                                                {
                                                                                    pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                                    message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <FilteredInput
                                                                                placeholder='Enter your passport number'
                                                                                value={form.passportId}
                                                                                onChange={(e) => handleChangeInfant(index, 'passportId', e.target.value)}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    {/* <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportIssuing${index}`}
                                                                            label="Passport Expiry Date"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportIssuingDay, passportIssuingMonth, passportIssuingYear } = forms[index] || {};
                                                                                        if (!passportIssuingDay || !passportIssuingMonth || !passportIssuingYear) {
                                                                                            return Promise.reject(new Error("Passport expiry date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4} className=''>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingDay', value)}
                                                                                        value={form.passportIssuingDay}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingMonth', value)}
                                                                                        value={form.passportIssuingMonth}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingYear', value)}
                                                                                        value={form.passportIssuingYear}
                                                                                        style={{ width: '100%' }}
                                                                                    >
                                                                                        {futurePassportYears.map(y => (
                                                                                            <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col> */}


                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportIssuing${index}`}
                                                                            label="Passport Issue Date"
                                                                            validateTrigger="onBlur"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportIssuingDay, passportIssuingMonth, passportIssuingYear } = forms[index] || {};
                                                                                        if (!passportIssuingDay || !passportIssuingMonth || !passportIssuingYear) {
                                                                                            return Promise.reject(new Error("Passport Issue Date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4} className=''>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingDay', value)}
                                                                                        value={form.passportIssuingDay}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingMonth', value)}
                                                                                        value={form.passportIssuingMonth}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportIssuingYear', value)}
                                                                                        value={form.passportIssuingYear}
                                                                                        style={{ width: '80px' }}
                                                                                    >
                                                                                        {pastPassportYears.map(y => (
                                                                                            <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col md={8} className='w-100'>
                                                                        <Form.Item
                                                                            name={`PassportExpiry${index}`}
                                                                            label="Passport Expiry Date"
                                                                            validateTrigger="onBlur"
                                                                            rules={[
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const { passportExpiryDay, passportExpiryMonth, passportExpiryYear } = forms[index] || {};
                                                                                        if (!passportExpiryDay || !passportExpiryMonth || !passportExpiryYear) {
                                                                                            return Promise.reject(new Error("Passport expiry date is required"));
                                                                                        }
                                                                                        return Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Row gutter={4}>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Day"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportExpiryDay', value)}
                                                                                        value={form.passportExpiryDay}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {days.map(d => (
                                                                                            <Option key={`expiry-day-${d}`} value={d}>{d}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Month"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportExpiryMonth', value)}
                                                                                        value={form.passportExpiryMonth}
                                                                                        style={{ width: '75px' }}
                                                                                    >
                                                                                        {months.map((m, idx) => (
                                                                                            <Option key={`expiry-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <Select
                                                                                        placeholder="Year"
                                                                                        onChange={(value) => handleChangeInfant(index, 'passportExpiryYear', value)}
                                                                                        value={form.passportExpiryYear}
                                                                                        style={{ width: '80px' }}
                                                                                    >
                                                                                        {getExpiryYears(form.passportIssuingYear).map((y) => (
                                                                                            <Option key={`expiry-year-${y}`} value={y}>{y}</Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </>
                                                            }

                                                        </Row>
                                                    </Panel>
                                                    // </Collapse>
                                                ))}
                                            </>
                                        }

                                    </Collapse>

                                    <h4 className='mt-2 mb-2'>Contact Details</h4>
                                    <Row gutter={16}>
                                        <Col md={12} className='w-100 mb-2'>
                                            <Form.Item
                                                name="contacts"
                                                label="Mobile Number"
                                                rules={[
                                                    {
                                                        required: true,
                                                        validator: validatePhone,
                                                    },
                                                ]}
                                                validateTrigger={['onSubmit']}
                                            >
                                                <PhoneInput
                                                    defaultCountry={'in'}
                                                    forceDialCode={true}
                                                    disableDialCodeAndPrefix={true}
                                                    showDisabledDialCodeAndPrefix={true}
                                                    placeholder="Enter Mobile Number"
                                                    className="w-100 custom-phone-inputs"
                                                    disableFormatting={true}
                                                    value={phoneValue}
                                                    onChange={handlePhoneChange}

                                                />
                                            </Form.Item>
                                        </Col>
                                        {/* <Col md={12} className='w-100'>
                                            <Form.Item
                                                name="email"
                                                label="Email"
                                                className="pulse_input"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Email  is required",
                                                    },
                                                ]}
                                            >
                                                <FilteredInput
                                                    placeholder='Enter your Email'
                                                    prefix={<FaRegEnvelope className="me-2" />}

                                                />
                                            </Form.Item>
                                        </Col> */}

                                        <Col md={12} className="w-100">
                                            <Form.Item
                                                name="email"
                                                label="Email"
                                                className="pulse_input"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Email is required",
                                                    },
                                                    {
                                                        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                                                        message: "Please enter a valid email address",
                                                    },
                                                ]}
                                            >
                                                <FilteredInput
                                                    placeholder="Enter your Email"
                                                    prefix={<FaRegEnvelope className="me-2" />}
                                                    onKeyDown={(e) => {
                                                        if (e.key === " ") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        e.target.value = e.target.value.replace(/\s/g, "");
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>

                                        {/* <span className='d-flex justify-content-between align-items-center'>Your ticket will be sent to this email address</span> */}
                                        <Col md={24} className='w-100'>
                                            <Form.Item
                                                name="billing_address"
                                                label="Billing Address"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Billing Address is required",
                                                    },
                                                ]}
                                            >
                                                {/* <Input
                                            maxLength={10}
                                            placeholder='Enter your billing address'
                                        /> */}
                                                <TextArea
                                                    placeholder="Enter your billing address"
                                                    rows={2}
                                                    style={{ height: 'auto', }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Title level={5} className='fw-bold mb-2'>
                                        <Checkbox onChange={onChange} className='me-3 me-md-2' /> Enter GST Details (Optional)</Title>

                                    {checked &&
                                        <div>
                                            <Row gutter={16}>
                                                <Col md={8} xs={24} className='mb-3'>
                                                    <Form.Item
                                                        name="gstNumber"
                                                        label="GST Number"
                                                        rules={[{ required: true, message: 'Please enter GST Number' }]}
                                                    >
                                                        <FilteredInput placeholder="Enter GST Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col md={8} xs={24} className='mb-3'>
                                                    <Form.Item
                                                        name="companyName"
                                                        label="Company Name"
                                                        rules={[{ required: true, message: 'Please enter Company Name' }]}
                                                    >
                                                        <FilteredInput placeholder="Enter Company Name" />
                                                    </Form.Item>
                                                </Col>
                                                <Col md={8} xs={24} className='mb-3'>
                                                    <Form.Item
                                                        name="businessEmail"
                                                        label="Business Email ID"
                                                        rules={[{ required: true, message: 'Please enter Business Email ID' }, { type: 'email', message: 'Please enter a valid email' }]}
                                                    >
                                                        <FilteredInput placeholder="Enter Business Email ID" prefix={<FaRegEnvelope />} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col md={8} xs={24} className='mb-3'>
                                                    <Form.Item
                                                        name="mobile"
                                                        label="Mobile Number"
                                                        rules={[{ required: true, message: 'Please enter Mobile Number' }]}
                                                    >
                                                        <FilteredInput placeholder="Enter Mobile Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col md={16} xs={24} className='mb-3'>
                                                    <Form.Item
                                                        name="companyAddress"
                                                        label="Company Address"
                                                        rules={[{ required: true, message: 'Please enter Company Address' }]}
                                                    >
                                                        <FilteredInput placeholder="Enter Company Address" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    }

                                    <Form.Item
                                        name="agree"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                validator: (_, value) =>
                                                    value
                                                        ? Promise.resolve()
                                                        : Promise.reject("Please click on checkbox to continue."),
                                            },
                                        ]}
                                    >
                                        <span className="mb-2 d-flex align-items-start gap-2">
                                            <Checkbox
                                                onChange={(e) => {
                                                    setIsCheckboxChecked(e.target.checked);
                                                    setHasTriedSubmit(true);
                                                }}
                                                className='me-3 me-md-2' />
                                            <label htmlFor="terms">
                                                I understand and agree with the{" "}

                                                the{" "}
                                                <Link
                                                    aria-label="Privacy Policy"
                                                    to="/privacy-policy"
                                                    target="_blank"
                                                    className="text-primary"
                                                >
                                                    Privacy Policy
                                                </Link>
                                                , the{" "}
                                                <Link
                                                    aria-label="User Agreement"
                                                    to="/user-agreement"
                                                    target="_blank"
                                                    className="text-primary"
                                                >
                                                    User Agreement
                                                </Link>{" "}
                                                and{" "}

                                                <Link
                                                    aria-label="Terms and Conditions"
                                                    to="/terms-conditions"
                                                    target="_blank"
                                                    className="text-primary"
                                                >
                                                    Fare Rules,  Terms & Conditions
                                                </Link>{" "}
                                                of SuperbWorldTrip.
                                            </label>
                                        </span>

                                    </Form.Item>

                                    {/* {!addonsCompHide && */}
                                    <Button
                                        onClick={() => handleProceed()}
                                        className='btn btn-primary d-inline-block float-end px-4 rounded my-3 d-none d-sm-block'
                                        aria-label="Proceed">
                                        {isFormValid ? "Continue" : "Proceed"}
                                    </Button>
                                    {/* } */}
                                    {/* </Form> */}
                                </div>
                            }

                        </div>



                    </Skeleton>

                    <PriceFareMobileViewTripJack
                        loading={loading}
                        totalBookingPrice={totalBookingPrice}
                        flightDetails={flightDetails}
                        totalAmount={totalAmount}
                        mealTotalAmount={mealTotalAmount}
                        open={open}
                        handleOpenChange={handleOpenChange}
                        addonsCompHide={addonsCompHide}
                        handleProceed={handleProceed}
                        handleConfirmAndPay={handleConfirmAndPay}
                        setConvenienceChargeTotalFareModal={setConvenienceChargeTotalFareModal}
                        mealTotalAmountRetrun={mealTotalAmountRetrun}
                        totalAmountBaggageReturn={totalAmountBaggageReturn}
                        applyDiscountShow={applyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        totalAfterDiscount={totalAfterDiscount}
                        isFormValid={isFormValid}
                        totalSeatPrice={totalSeatPrice}
                        totalSeatsPriceReturn={totalSeatsPriceReturn}
                    />
                </Form>

                {addonsCompHide &&
                    <>
                        <div ref={component4Ref}>
                            <AddonsFlightTripJack
                                flightDetails={flightDetails}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                totalSelectMeals={totalSelectMeals}
                                addMeal={addMeal}
                                removeMeal={removeMeal}
                                selectedMeals={selectedMeals}
                                addonsCompHide={addonsCompHide}
                                loading={loading}
                                selectedMealsReturn={selectedMealsReturn}
                                addMealReturn={addMealReturn}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                removeMealReturn={removeMealReturn}
                                addBaggageReturn={addBaggageReturn}
                                removeBaggageReturn={removeBaggageReturn}
                                selectedBaggagesReturn={selectedBaggagesReturn}
                                skipAddonAndPayNow={skipAddonAndPayNow}
                                totalSeatPrice={totalSeatPrice}
                                setTotalSeatPrice={setTotalSeatPrice}
                                selectedSeats={selectedSeats}
                                setSelectedSeats={setSelectedSeats}
                                seatsList={seatsList}
                                setSeatsList={setSeatsList}
                                totalSeatsPriceReturn={totalSeatsPriceReturn}
                                setTotalSeatPriceReturn={setTotalSeatPriceReturn}
                                selectedSeatsReturn={selectedSeatsReturn}
                                setSelectedSeatsReturn={setSelectedSeatsReturn}
                                seatsListReturn={seatsListReturn}
                                setSeatsListReturn={setSeatsListReturn}
                                setSelectedMeals={setSelectedMeals}
                                setMealTotalAmount={setMealTotalAmount}
                                setSelectedMealsReturn={setSelectedMealsReturn}
                                setMealTotalAmountReturn={setMealTotalAmountReturn}
                                setSelectedBaggages={setSelectedBaggages}
                                setSelectedBaggagesReturn={setSelectedBaggagesReturn}
                                setTotalAmountBaggageReturn={setTotalAmountBaggageReturn}
                                setTotalAmount={setTotalAmount}
                            />

                            <Col md={24} className='text-center mb-md-0 mb-5'>
                                <Button
                                    onClick={() => setConvenienceChargeTotalFareModal(true)}
                                    type='primary' style={{ height: "42px" }}
                                    className='btn btn-primary menu-block  rounded mt-3 d-md-inline d-none text-center'>
                                    Continue To Pay
                                </Button>
                            </Col>
                        </div>
                    </>
                }
            </div>

            <Modal
                className='Gallery_cntr p-0'
                open={convenienceChargeTotalFareModal}
                footer={null}
                onCancel={() => setConvenienceChargeTotalFareModal(false)}
                centered
                destroyOnClose={true}
            >
                {convenienceCharge && (
                    <ConvenienceChargeTotalFareTripjack
                        convenienceCharge={convenienceCharge}
                        flightDetails={flightDetails}
                        calculatedFee={calculatedFee}
                        applyDiscountShow={applyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        finalTotal={finalTotal}
                        handleConfirmAndPay={handleConfirmAndPay}
                        totalAmountBaggageReturn={totalAmountBaggageReturn}
                        totalAmount={totalAmount}
                        mealTotalAmountRetrun={mealTotalAmountRetrun}
                        mealTotalAmount={mealTotalAmount}
                        totalBookingPrice={totalBookingPrice}
                        applicableChargeData={applicableChargeData}
                        totalAfterDiscount={totalAfterDiscount}
                        totalSeatPrice={totalSeatPrice}
                        totalSeatsPriceReturn={totalSeatsPriceReturn}
                    />
                )}

            </Modal>

            <Modal
                className='Gallery_cntr p-0'
                open={isModalOpen}
                footer={null}
                onCancel={() => setIsModalOpen(false)}
                centered
                destroyOnClose={true}
            >
                <DepartureBaggageDetails flightDetails={flightDetails} />
            </Modal>

            <Modal
                className='Gallery_cntr p-0'
                open={isModalOpenReturn}
                footer={null}
                onCancel={() => setIsModalOpenReturn(false)}
                centered
                destroyOnClose={true}
            >
                <ReturnBaggageDetails flightDetails={flightDetails} />
            </Modal>

            <Modal
                className='Gallery_cntr p-0'
                open={isModalTravellerDetails}
                footer={null}
                onCancel={() => setIsModalOpenTravellerDetails(false)}
                centered
                destroyOnClose={true}
            >
                <TravellerDetailsTripjack
                    onPayment={onPayment}
                    selectPayloadData={selectPayloadData}
                    flightDetails={flightDetails}
                    setIsModalOpenTravellerDetails={setIsModalOpenTravellerDetails}
                    checked={checked}
                    setAddonsCompHide={setAddonsCompHide}
                    TotalAmountConvenienceCharge={TotalAmountConvenienceCharge}
                    totalBookingPrice={totalBookingPrice}
                    applyDiscountShow={applyDiscountShow}
                    applicableChargeData={applicableChargeData}
                    calculatedFee={calculatedFee}
                    finalTotal={finalTotal}
                    discountAmountOffer={discountAmountOffer}

                />
                {!addonsCompHide &&
                    <div className="text-end">
                        <Button
                            type="primary"
                            className="tabs-popup-btn fw-bold mt-2 mx-2"
                            onClick={() => setIsModalOpenTravellerDetails(false)}
                            aria-label="edit"
                        >
                            Edit
                        </Button>
                        <Button
                            className="tabs-popup-btn fw-bold mt-2"
                            type="primary"
                            onClick={() => {
                                const ssrInfo = flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo;
                                const hasMeals = ssrInfo?.MEAL && ssrInfo.MEAL.length > 0;
                                const hasBaggage = ssrInfo?.BAGGAGE && ssrInfo.BAGGAGE.length > 0;
                                if (!hasMeals && !hasBaggage) {
                                    handleConfirmAndPay();
                                } else {
                                    setAddonsCompHide(true);
                                    setCollapseCard(false);
                                    setIsModalOpenTravellerDetails(false);
                                }
                            }}
                            aria-label="confirm and pay"
                        >
                            {
                                (!flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.MEAL?.length &&
                                    !flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.BAGGAGE?.length)
                                    ? "Confirm and Pay"
                                    : "Confirm"
                            }
                        </Button>

                    </div>
                }
            </Modal>

            <Modal
                className='Gallery_cntr p-3'
                open={bookingLoader}
                footer={null}
                onCancel={() => { setBookingLoader(false), setBookingMessageError(false) }}
                centered
                destroyOnClose={true}
                width={400}
            >
                {!bookingMessageError ?
                    <div className='text-center py-5'>
                        <img src={flightLoader} style={{ height: "100px", width: "100px" }} alt='loader' />
                        <h4>Loading ...</h4>
                    </div>
                    :

                    <div className='text-center py-4' >
                        <h4 className='mb-1'>Uh Oh!</h4>
                        <h4 style={{ color: "red" }}>{bookingMessage}</h4>
                        <button onClick={() => navigate(-1)} className='btn btn-primary py-2 d-block mt-3 border-0 m-auto' aria-label="ok got it">Go Back </button>
                    </div>
                }
            </Modal>

        </div>

    )
}

export default BookingFlightTripJack